module.exports = __webpack_public_path__ + "static/media/130.db9930a9.svg";